import React from "react";

const Design = () => {
  return <React.Fragment>Design</React.Fragment>;
};

export default Design;
